// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

// Main page scroll restoration – run first so it works even if a require() fails below.
// Handles: Turbolinks (turbolinks:load), Firefox bfcache (pageshow), popstate, load.
// Works across Chrome, Firefox, Safari, Edge and all mobile browsers.
(function() {
  var SCROLL_POSITION_KEY = 'scrollPosition';
  var SCROLL_STATE_KEY = 'scrollPageState_v1'; // richer state: scroll pos + pagination ref
  var _restoreTimer = null;
  var _restoreInProgress = false; // guard: prevents concurrent runRestoreWithPagination calls
  var LOG = function() { try { console.log.apply(console, ['[scroll-restore]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {} };

  function isMainPage() { var p = (window.location.pathname || ''); return p === '/' || p === ''; }
  function isAdDetailPath(pathname) {
    if (!pathname || pathname === '/') return false;
    var seg = (pathname.replace(/^\/|\/$/g, '') || '').split('/');
    return seg.length === 4 && /^\d+$/.test(seg[3]);
  }
  function getStoredScroll() {
    try {
      var s = (typeof sessionStorage !== 'undefined' && sessionStorage.getItem(SCROLL_POSITION_KEY)) ||
              (typeof localStorage !== 'undefined' && localStorage.getItem(SCROLL_POSITION_KEY));
      return s || null;
    } catch (e) { return null; }
  }
  function clearStoredScroll() {
    try { sessionStorage.removeItem(SCROLL_POSITION_KEY); } catch (e) {}
    try { localStorage.removeItem(SCROLL_POSITION_KEY); } catch (e) {}
    try { sessionStorage.removeItem(SCROLL_STATE_KEY); } catch (e) {}
    LOG('cleared');
  }

  // ── PAGINATION STATE ───────────────────────────────────────────────────────
  // Returns the href of the most-advanced "next page" link across all three
  // pagination containers.  This tells us which pages have been loaded:
  //   href='/?page=4' → pages 1–3 are in the DOM, page 4 is next.
  function getNextPageRef() {
    var sels = ['.first_pagination .next_page', '.second_pagination .next_page', '.third_pagination .next_page'];
    var best = null, bestPage = 0;
    for (var i = 0; i < sels.length; i++) {
      var el = document.querySelector(sels[i]);
      if (!el) continue;
      var href = el.getAttribute('href');
      if (!href) continue;
      var m = href.match(/[?&]page=(\d+)/);
      var p = m ? parseInt(m[1], 10) : 2;
      if (p > bestPage) { bestPage = p; best = href; }
    }
    return best; // null → all pages loaded (or only page 1 exists)
  }

  function extractPageNum(url) {
    if (!url) return 2;
    var m = url.match(/[?&]page=(\d+)/);
    return m ? parseInt(m[1], 10) : 2;
  }

  function getSavedState() {
    try {
      var s = sessionStorage.getItem(SCROLL_STATE_KEY);
      return s ? JSON.parse(s) : null;
    } catch (e) { return null; }
  }

  // scrollToY: use behavior:'instant' to override CSS scroll-behavior and bypass
  // any deferred browser scroll (critical for Firefox bfcache restore).
  function scrollToY(y) {
    try {
      window.scrollTo({ top: y, left: 0, behavior: 'instant' });
    } catch (e) {
      // fallback for very old browsers that don't accept the options object
      window.scrollTo(0, y);
    }
    try { if (document.documentElement) document.documentElement.scrollTop = y; } catch (e) {}
    try { if (document.body) document.body.scrollTop = y; } catch (e) {}
  }

  function doRestore() {
    if (!isMainPage()) return;
    try {
      var stored = getStoredScroll();
      if (!stored) return;
      var y = parseInt(stored, 10);
      if (!isFinite(y) || y < 0) return;
      LOG('doRestore y=', y);
      // Synchronous attempt – works for Chrome / Edge / Safari.
      scrollToY(y);
      // rAF attempt – Firefox bfcache may apply its own scroll AFTER the event fires,
      // overwriting our synchronous call. Running in the next animation frame wins.
      if (typeof requestAnimationFrame === 'function') {
        requestAnimationFrame(function() { scrollToY(y); });
      }
    } catch (e) { LOG('doRestore error', e); }
  }

  function runRestoreSequence(from) {
    LOG('runRestoreSequence from=', from);
    if (!isMainPage()) return;
    if (!getStoredScroll()) return;
    // Cancel any previously scheduled clear so concurrent sequences don't race.
    if (_restoreTimer) { clearTimeout(_restoreTimer); _restoreTimer = null; }
    doRestore();
    setTimeout(doRestore, 50);
    setTimeout(doRestore, 150);
    setTimeout(doRestore, 300);
    setTimeout(doRestore, 500);
    setTimeout(doRestore, 900);
    setTimeout(doRestore, 1300); // extra late retry for slow mobile connections
    _restoreTimer = setTimeout(function() {
      clearStoredScroll();
      _restoreTimer = null;
    }, 1800);
  }

  // Pagination-aware restore: if the user had loaded extra pages before navigating away,
  // reload those pages first so the page is tall enough for the saved scroll position.
  // Falls back to runRestoreSequence if state is unavailable or jQuery isn't ready.
  // Guard: only one restore may run at a time — turbolinks:load, window.load, and pageshow
  // can all fire for the same navigation, which would cause duplicate AJAX page loads.
  function runRestoreWithPagination(from) {
    LOG('runRestoreWithPagination from=', from);
    if (!isMainPage()) return;
    if (_restoreInProgress) { LOG('restore in progress, skipping duplicate from=', from); return; }

    _restoreInProgress = true;
    // Clear the guard ~2.1 s after this call — slightly longer than runRestoreSequence's
    // own 1.8 s clear window so the guard stays active through the full sequence.
    var _releaseGuard = function() {
      setTimeout(function() { _restoreInProgress = false; }, 2100);
    };

    var state = getSavedState();
    if (!state || !isFinite(state.y) || state.y < 0) {
      runRestoreSequence(from);
      _releaseGuard();
      return;
    }

    var savedNextRef = state.nextRef; // e.g. '/?page=4' → pages 1–3 were loaded
    if (!savedNextRef) {
      // All pages were loaded or only page 1 existed — just scroll
      runRestoreSequence(from);
      _releaseGuard();
      return;
    }

    var savedNextPage = extractPageNum(savedNextRef); // page we need to reach
    var maxExtraLoads = Math.min(savedNextPage - 1, 10); // safety cap
    var loadCount = 0;

    function doScrollNow() {
      runRestoreSequence(from + '-afterPageLoad');
      _releaseGuard();
    }

    function tryLoadNext() {
      var currentRef = getNextPageRef();
      var currentNextPage = currentRef ? extractPageNum(currentRef) : Infinity;

      if (currentNextPage >= savedNextPage || loadCount >= maxExtraLoads) {
        doScrollNow();
        return;
      }

      var jq = window.jQuery || window.$;
      if (!jq || typeof jq.getScript !== 'function') { doScrollNow(); return; }

      // Pick the first available next_page link
      var nextEl = document.querySelector(
        '.first_pagination .next_page, .second_pagination .next_page, .third_pagination .next_page'
      );
      if (!nextEl) { doScrollNow(); return; }

      var nextUrl = nextEl.getAttribute('href');
      if (!nextUrl) { doScrollNow(); return; }

      loadCount++;
      LOG('loading page for scroll restore:', nextUrl);
      jq.getScript(nextUrl, function() { tryLoadNext(); })
        .fail(function() { doScrollNow(); });
    }

    tryLoadNext();
  }

  // Disable browser automatic scroll restoration globally so it never fights ours.
  // Set unconditionally (not just on main page) so it's always 'manual' for this tab,
  // regardless of which page the user initially lands on.
  if (typeof history !== 'undefined' && 'scrollRestoration' in history) {
    try { history.scrollRestoration = 'manual'; } catch (e) {}
  }

  function saveScroll() {
    var el = document.documentElement || document.body;
    var y = String(window.pageYOffset !== undefined ? window.pageYOffset : el.scrollTop);
    try { sessionStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    try { localStorage.setItem(SCROLL_POSITION_KEY, y); } catch (e) {}
    try {
      var state = { y: parseInt(y, 10), nextRef: getNextPageRef() };
      sessionStorage.setItem(SCROLL_STATE_KEY, JSON.stringify(state));
    } catch (e) {}
    LOG('SAVED y=', y);
  }

  // ── SAVE ──────────────────────────────────────────────────────────────────

  // 1. Mouse click on an auction link (primary desktop path).
  document.addEventListener('click', function(e) {
    var link = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!link || !link.href || link.target === '_blank' || link.getAttribute('rel') === 'external') return;
    if (!isMainPage()) return;
    try {
      var href = link.getAttribute('href');
      if (!href || href.indexOf('#') === 0 || href.indexOf('javascript:') === 0) return;
      var url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return;
      if (!isAdDetailPath(url.pathname)) return;
      saveScroll();
    } catch (err) { LOG('click error', err); }
  }, true);

  // 2. Turbolinks before-visit: catches keyboard Enter, touch, and programmatic navigation.
  document.addEventListener('turbolinks:before-visit', function() {
    if (isMainPage()) saveScroll();
  });

  // 3. pagehide: fires when browser (non-Turbolinks) navigates away, including bfcache freeze.
  window.addEventListener('pagehide', function() { if (isMainPage()) saveScroll(); });

  // 4. beforeunload: extra fallback (some browsers skip pagehide on hard navigation).
  window.addEventListener('beforeunload', function() { if (isMainPage()) saveScroll(); });

  // ── RESTORE ───────────────────────────────────────────────────────────────

  // 1. turbolinks:load – fires on EVERY Turbolinks navigation (forward AND back).
  //    Uses pagination-aware restore so extra pages are reloaded before scrolling.
  document.addEventListener('turbolinks:load', function() {
    LOG('turbolinks:load');
    if (!isMainPage() || !getStoredScroll()) return;
    runRestoreWithPagination('turbolinks:load');
  });

  // 2. popstate – Firefox sometimes fires this for back navigation WITHOUT firing
  //    turbolinks:load (e.g. when bfcache intervenes but Turbolinks still pushes state).
  //    Uses runRestoreWithPagination so extra pages are reloaded when needed.
  //    Checks _restoreInProgress first: if turbolinks:load already started restoration
  //    we skip here so the two paths don't race and clear each other's scroll state.
  window.addEventListener('popstate', function() {
    if (!isMainPage() || !getStoredScroll()) return;
    LOG('popstate');
    // Defer so the DOM has updated to the target page before we attempt restoration.
    setTimeout(function() {
      if (!_restoreInProgress) runRestoreWithPagination('popstate');
    }, 0);
    setTimeout(function() {
      if (!_restoreInProgress) runRestoreWithPagination('popstate-delayed');
    }, 80);
  });

  // 3. load – initial page load (not fired on Turbolinks navigations).
  //    Uses pagination-aware restore since only page 1 is present after a full reload.
  window.addEventListener('load', function() { LOG('load'); runRestoreWithPagination('load'); });

  // 4. pageshow – bfcache restore in Safari, Firefox, iOS Chrome.
  //    persisted=true: browser restored page from bfcache (Turbolinks may not fire).
  //    Firefox bfcache applies ITS OWN scroll position after pageshow fires,
  //    so we need the rAF inside doRestore AND extra setTimeout passes here.
  window.addEventListener('pageshow', function(ev) {
    LOG('pageshow persisted=', ev.persisted, 'hasKey=', !!getStoredScroll());
    if (!isMainPage() || !getStoredScroll()) return;
    if (ev.persisted) {
      // Don't call synchronously – let the bfcache apply its scroll first,
      // then override it in the next frame and at increasing intervals.
      setTimeout(function() { runRestoreSequence('pageshow-bfcache'); }, 0);
      setTimeout(function() { runRestoreSequence('pageshow-bfcache2'); }, 100);
      setTimeout(function() { runRestoreSequence('pageshow-bfcache3'); }, 300);
    } else {
      // Not from bfcache: page reloaded from server, only page 1 present.
      runRestoreWithPagination('pageshow');
    }
  });

  // 5. visibilitychange – handles tab switching on Android Chrome and Firefox for Android.
  document.addEventListener('visibilitychange', function() {
    if (document.visibilityState === 'visible' && isMainPage() && getStoredScroll()) {
      runRestoreSequence('visibilitychange');
    }
  });
})();

require("cocoon")
require("@rails/ujs").start()
require("@rails/activestorage").start()
require("channels")
require('jquery')
require('bootstrap')
require('website/bootstrap-select.min')
require('website/jquery-ui-1.10.1.custom.min')
require('website/jquery.jscroll')
require('website/jquery.timepicker.min')
import I18n from 'i18n-js'
window.I18n = I18n
require('i18n/translations')
// require('website/jquery.keyboard')
require('bootstrap-datepicker')
require('front/auction')
require('website/maps')
require("packs/select2setup")
require('website/acommon')
require('channels/auction_channel')

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)
// Support component names relative to this directory:
// var componentRequireContext = require.context("components", true);
// var ReactRailsUJS = require("react_ujs");
// ReactRailsUJS.useContext(componentRequireContext);

require("trix")
require("@rails/actiontext")

// Ensure login modal opens when LOGIN button is clicked (Bootstrap 5; works with Turbolinks).
(function() {
  function openLoginModal(e) {
    var trigger = e.target.closest('[data-bs-target="#loginModal"]');
    if (!trigger) return;
    var el = document.getElementById('loginModal');
    if (!el || typeof bootstrap === 'undefined') return;
    e.preventDefault();
    var modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }

  document.addEventListener('click', openLoginModal, true);
})();

// Footer is always visible (no scroll-based show/hide)